<template>
  <q-dialog ref="dialog" persistent>
    <q-card
      class="error text-center full-width q-pt-md q-pb-sm border-radius-8"
    >
      <q-card-section class="q-pt-none">
        <q-icon name="schedule" size="46px" color="grey-6" />
        <div class="text-weight-bolder font-size-16 q-pt-sm">
          <span>{{ title }}</span>
        </div>
        <div v-if="describe" class="font-size-16 q-pt-sm">
          <span>{{ describe }}</span>
        </div>
        <div v-if="showOrderId" class="font-size-16 q-pt-sm q-mt-sm">
          <span>{{ $t('waiting.orderId') }}:{{ orderId }}</span>
        </div>
        <div v-if="orderAmount" class="font-size-16 q-pt-sm">
          <span>{{ $t('waiting.orderPrice') }}: Rp {{ orderAmount }}</span>
        </div>
        <div class="q-mt-lg q-px-lg">
          <q-btn
            no-caps
            unelevated
            color="primary"
            class="border-radius-8 text-weight-bolder full-width"
            :label="okText"
            @click="confirm"
          />
        </div>
        <div v-if="showCancel" class="q-mt-md q-px-lg">
          <q-btn
            no-caps
            outline
            unelevated
            class="border-radius-8 text-weight-bolder full-width"
            :label="cancelText"
            @click="cancel"
          />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    describe: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: '',
    },
    showCancel: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
    showOrderId: {
      type: Boolean,
      default: false,
    },
    orderAmount: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    // 以下方法是必需的 (不要改变它的名称 --> "show")
    show() {
      this.$refs.dialog.show();
    },
    // 以下方法是必需的 (不要改变它的名称 --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },
    confirm() {
      // 带有有效负载：this.$emit('ok', { ... })
      this.$emit('ok');
      // 然后隐藏对话框
      this.hide();
    },
    cancel() {
      this.$router.push({ name: 'products-list' });
      // 隐藏对话框
      this.hide();
    },
  },
};
</script>
